import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Button, DesignType } from '@/components/atoms/Button';
import { dispatchCloseQueuedModalEvent } from '@/components/molecules/Modal';
import StepCard from './StepCard';
import Styled from './styled';

export interface IProps extends HTMLAttributes<HTMLDivElement> {
  readonly showModal?: boolean;
  readonly toggleModal?: () => void;
  readonly images: string[];
}

/**
 * @deprecated to be dropped or replaced in upcoming design system; avoid used
 */
function COVIDModal({ images, className, ...props }: IProps): JSX.Element {
  const closeModal = (e: React.MouseEvent) => dispatchCloseQueuedModalEvent(e.target as Element);

  return (
    <Styled
      {...props}
      title="We fix your car, while you stay safe"
      className={classNames('COVIDModal', className)}
    >
      <StepCard key={1} title="Contact-free collection" imgSrc={images[0]}>
        Our drivers maintain safe distances, we adhere to distance regulations and offer a totally
        contact-free service.
      </StepCard>

      <StepCard key={2} title="You're in safe hands" imgSrc={images[1]}>
        Our drivers wear gloves and masks on each collection and delivery, so you have complete peace of mind
        behind the wheel.
      </StepCard>

      <StepCard key={3} title="Take some time to yourself" imgSrc={images[2]}>
        Our drivers collect your car, take it to be serviced and bring it right back to you. You can take it
        easy, while we do the hard work.
      </StepCard>
      <Button designType={DesignType.PRIMARY} noIcon onClick={(e: React.MouseEvent) => closeModal(e)}>
        Close
      </Button>
    </Styled>
  );
}

export default COVIDModal;
